import {Component, ViewChild} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationEnd,NavigationStart } from '@angular/router';
import { APPCONFIG } from './config'
import { LayoutService } from './layout/layout.service';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { HttpService } from './shared/services/http.service';
import { ErrorHandler } from './shared/services/error-handler.service';
import { SessionHandler } from './shared/services/session-handler.service';
import { dialogComponent } from './dialog/dialog.component';
import {TranslateService} from 'ng2-translate';
import { CommonService } from './shared/services/common.service';

// 3rd
import 'styles/font-awesome.scss';
import 'styles/material2-theme.scss';
import 'styles/bootstrap.scss';
// custom
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';

@Component({
    selector: 'app-root',
    template: require('./app.component.html'),
    providers: [LayoutService,HttpService,ErrorHandler,SessionHandler]
})
export class AppComponent {
    AppConfig: any;
    dialogRef;
    constructor(private router: Router, private layoutService:LayoutService,private sessionHandler:SessionHandler,public dialog: MdDialog,
        private translate: TranslateService,private commonService : CommonService) {
        let country = this.sessionHandler.getItem("country");
        // if(country == 'BE') {
        //     translate.addLangs(["English","French","German","Dutch"]);
        // } else if(country == 'NL') {
        //     translate.addLangs(["English","Dutch"]);
        // } else if(country == 'FR') {
        //     translate.addLangs(["English","French"]);
        // } else if(country == 'DE') {
        //     translate.addLangs(["English","German"]);
        // }

       // translate.addLangs(["English","French","German"]);
        translate.addLangs(["English"]);
        let defaultLanguage = this.sessionHandler.getItem("defaultLanguage");
        if(defaultLanguage) {
            translate.use(defaultLanguage);            
        } else {
            this.sessionHandler.saveItem("defaultLanguage",'English');
            translate.setDefaultLang('English');
            translate.use('English');
        }
    }

    ngOnInit() {
        this.AppConfig = APPCONFIG;

        //For GA
        // this.router.events.subscribe((evt) => {
        //     if ((evt instanceof NavigationEnd)) {
        //         window.dataLayer = window.dataLayer || [];
        //         function gtag(){dataLayer.push(arguments);}
        //         gtag('js', new Date());
        //         gtag('config', 'UA-113291106-1',{'page_location': window.location.href,'page_path': window.location.hash.substr(1)});
        //     }
        // });
        // Scroll to top on route change
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationStart)) {
                return;
                
            } else {
                let loginData = JSON.parse(localStorage.getItem('loginData'));
                if(!loginData && evt['url']=="/"){
                    this.router.navigateByUrl('/login');
                }
                if (evt['url'] == '/app/home') {
                    this.sessionHandler.saveItem("isHome", 'true');
                }if (evt['url'] != '/app/home') {
                    this.sessionHandler.saveItem("isHome", 'false');
                }
                if (evt['url'] != '/login') {
                    this.sessionHandler.setRedirectionUrl(evt['url']);
                    localStorage.setItem('redirect', this.sessionHandler.getRedirectionUrl());
                    if(evt['url'].indexOf('icb') > -1) {
                        this.sessionHandler.saveItem("isIcb", 'true');
                    }
                    else if(evt['url'] != '/app/trade/details'){
                        this.sessionHandler.saveItem("isIcb", 'false');
                    }
                    // let loginData = JSON.parse(localStorage.getItem('loginData'));
                    // let loginData = JSON.parse(window. sessionStorage. getItem("loginData"));
                    let timestamp = localStorage.getItem('timestamp');
                    
                    if(loginData && evt['url']=== "/"){

                        const roles = loginData.role || [];
                    
                        if (this.commonService.isOnlyFOCRole(roles)) {
                            this.router.navigateByUrl('/app/foc_dashboard');
                        }
                        else if(loginData.appAccess=='ICB'){
                            this.router.navigateByUrl('/app/icb/dashboard');
                        }
                        else if(loginData.appAccess == 'WRT' || loginData.appAccess=='BOTH'){    
                            this.router.navigateByUrl('/app/dashboard');
                        }
                    }
                    if(loginData  && (!loginData.role || loginData.role.length < 1)){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'No role assigned to user. Please contact your administrator.';
                        this.dialogRef.afterClosed().subscribe(result => {
                            if(result) {
                                localStorage.clear();
                                this.router.navigateByUrl('/login');
                            }
                            this.dialogRef = null;
                        });
                    } else if(loginData){
                        // for(let u in loginData.role){
                        //     if(loginData.role[u] != 'TRADE_PARTNER' && evt['url'].indexOf('icb') > -1) {
                        //         this.dialogRef = this.dialog.open(dialogComponent);
                        //         this.dialogRef.componentInstance.msg = 'You are not authorized to view this page.';
                        //         this.dialogRef.afterClosed().subscribe(result => {
                        //             if(result) {
                        //                 localStorage.clear();
                        //                 this.router.navigateByUrl('/login');
                        //             }
                        //             this.dialogRef = null;
                        //         });
                        //     }
                        // }
                    }
                    // TODO: Commented temporary...!!!
                    // if (evt['url'] != '/' &&(loginData == null || timestamp == null)){
                    //     this.dialogRef = this.dialog.open(dialogComponent);
                    //     this.dialogRef.componentInstance.msg = 'No login data found or session expired.Please login again.';
                    //     this.dialogRef.afterClosed().subscribe(result => {
                    //         if(result) {
                    //             localStorage.clear();
                    //             this.router.navigateByUrl('/login');
                    //         }
                    //         this.dialogRef = null;
                    //     });
                    // }
                }
            }
            document.body.scrollTop = 0;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.component.ts